import React, { Component } from "react";
import { connect } from "react-redux";
import QuestionNumber from "./../QuestionNumber";

import axios from "axios";
import Webcam from "react-webcam";
import config from "../../config/config-secret.json";
import { nextQuestion } from "./../../actions/assessment";

let count = 0;

export class AgreeDisagree extends Component {
  constructor(props) {
    super(props);

    this.webcamRef = React.createRef();
    this.cardRefs = [];

    this.state = {
      selectedId: null,
      hoveredId: null,
      focusedId: null,
    };
  }

  componentDidMount() {
    count = 0;
  }

  onUserMediaError = () => {
    alert("Can't access webcam, please contact administrator.");
  };

  onUserMedia = () => {};

  addCaptureImage = (imageb64, taken_at) => {
    axios
      .post(config.API_URL + `/administer_test/save_security_image/`, {
        imageb64,
        taken_at,
        tester_id: this.props.assessment.tester_id,
      })
      .catch((error) => {
        console.log(error);
      });
  };

  nextQuestion = async (id) => {
    if (count < 1) {
      count += 1;
      window.localStorage.setItem(
        this.props.assessment.key,
        JSON.stringify(this.props.assessment)
      );

      const { tester_id, ...last_session_info } = this.props.assessment;
      axios
        .post(config.API_URL + "/administer_test/update_tester_session_info/", {
          tester_id: tester_id,
          last_session_info: JSON.stringify(last_session_info),
        })
        .then((res) => {
          document.querySelector("#initloader").style.display = "none";
          this.props.nextQuestion(this.props.question_id, [id]);
        })
        .catch((error) => {
          document.querySelector("#initloader").style.display = "none";
          console.error(error);

          const serverMessage =
            error.response?.data?.message ||
            error.response?.data ||
            error.message ||
            "Unknown error";

          alert(
            `There appears to be a problem sending data to our server.
Please check your internet connection and try refreshing your browser.

Error details: ${serverMessage}

If the issue persists, please contact your administrator.`
          );
        });
    }
  };

  selectChoice = (index, id) => {
    this.setState({ selectedId: id });
    this.nextQuestion(id);
    if (this.props.assessment.has_security_features) {
      this.addCaptureImage(
        this.webcamRef.current.getScreenshot(),
        new Date()
      );
    }
  };

  handleCardKeyDown = (e, index) => {
    const total = this.props.choices.length;
    let next = null;

    if (e.key === "ArrowRight" || e.key === "ArrowDown") {
      e.preventDefault();
      next = (index + 1) % total;
    } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
      e.preventDefault();
      next = (index - 1 + total) % total;
    } else if (e.key === " " || e.key === "Enter") {
      e.preventDefault();
      this.selectChoice(index, this.props.choices[index].id);
      return;
    }

    if (next !== null && this.cardRefs[next]) {
      this.cardRefs[next].focus();
    }
  };

  render() {
    const { hoveredId, focusedId, selectedId } = this.state;

    return (
      <div className="question">
        {this.props.assessment.has_security_features && (
          <Webcam
            className="col-12 mb-4"
            style={{ position: "absolute", right: "100%", display: "block" }}
            screenshotFormat="image/jpeg"
            muted={false}
            ref={this.webcamRef}
            onUserMediaError={this.onUserMediaError}
            onUserMedia={this.onUserMedia}
          />
        )}

        <QuestionNumber />

        <h4>
          <span dangerouslySetInnerHTML={{ __html: this.props.questiontext }} />
        </h4>

        <div
          className="choices-btn choices-btn-scale btn-group d-xs-block"
          role="radiogroup"
          aria-label="Answer choices"
        >
          {this.props.choices.map((value, index) => {
            const isSelected = selectedId === value.id;
            // Show filled circle when selected, hovered, or focused
            const isActive = isSelected || hoveredId === value.id || focusedId === value.id;

            return (
              <label
                key={value.id}
                ref={(el) => (this.cardRefs[index] = el)}
                role="radio"
                aria-checked={isSelected}
                aria-label={value.choice.text}
                aria-posinset={index + 1}
                aria-setsize={this.props.choices.length}
                tabIndex={0}
                className={`btn btn-outline-light${isActive ? " active" : ""}`}
                htmlFor={"rdbAgreeDisagree" + value.id}
                onClick={() => this.selectChoice(index, value.id)}
                onKeyDown={(e) => this.handleCardKeyDown(e, index)}
                onFocus={() => this.setState({ focusedId: value.id })}
                onBlur={() => this.setState({ focusedId: null })}
                onMouseEnter={() => this.setState({ hoveredId: value.id })}
                onMouseLeave={() => this.setState({ hoveredId: null })}
                onTouchStart={() => this.setState({ hoveredId: value.id })}
                onTouchCancel={() => this.setState({ hoveredId: null })}
              >
                <div className="custom-control custom-radio">
                  <input
                    type="radio"
                    id={"rdbAgreeDisagree" + value.id}
                    name="choices"
                    className="with-gap"
                    value={value.value}
                    tabIndex={-1}
                    checked={isActive}
                    onChange={() => {}}
                  />
                  <label
                    className="custom-control-label rdb-choice"
                    htmlFor={"rdbAgreeDisagree" + value.id}
                    aria-hidden="true"
                  >
                    <span className="custom-radio-text">{value.choice.text}</span>
                  </label>
                </div>
              </label>
            );
          })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = (dispatch) => ({
  nextQuestion: (question_id, choice_ids) =>
    dispatch(nextQuestion(question_id, choice_ids)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AgreeDisagree);
